import React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { abbreviateNumber } from 'features/invest/utils/format';
const YLabels = ({ yLabels }) => (<View style={styles.container}>
    {yLabels.map((label) => (<Text Numbers-14 Secondary key={label} numberOfLines={1}>
        {abbreviateNumber(label)}
      </Text>))}
  </View>);
export default YLabels;
const styles = StyleSheet.create({
    container: {
        width: rem(60),
        height: rem(150),
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
});
